/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form-main');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.data = this.getProductData();

      this.updateAvailability();
      this.addEventListener('change', this.handleVariantChange.bind(this));
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      const selectedOptions = this.getSelectedOptions();
      this.variant = null;

      // Get selected variant data (if variant exists).
      this.variant = this.data.product.variants.find((v) =>
        v.options.every((val, index) => val === selectedOptions[index])
      );

      // Se la variante selezionata non è disponibile, trova automaticamente una disponibile
      if (this.variant && !this.variant.available && evt && evt.target) {
        this.autoSelectAvailableVariant(evt.target, selectedOptions);
        return; // Il cambio automatico triggererà un nuovo evento
      }

      if (this.variant) {
        this.updateMedia();
        this.updateUrl(evt);
        this.updateVariantInput();
      }

      this.updateAddToCartButton();
      this.updateAvailability();
      this.updatePrice();
      this.updateWeight();
      this.updateBarcode();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      VariantPicker.updateLabelText(evt);

      if(!window.quickAddOpened){
        this.trackVariantChangeAddToDatalayer({
          variant: this.variant,
          product: this.data.product
        });
      }

      this.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: {
          form: this.productForm,
          variant: this.variant,
          product: this.data.product
        }
      }));
    }

    trackVariantChangeAddToDatalayer = (data) => {
      const obj = {
        "event": "ee_view_item",
        "ecommerce": {
            "currency": "EUR",
            "value": data.variant.price / 100,
            "analyzify_source": "advanced",
            "implementation_type": "extension",
            "items": [
                {
                    "item_id": data.product.id,
                    "item_name": data.product.title,
                    "item_brand": data.product.vendor,
                    "item_category": data.product.type,
                    "item_sku": data.variant.sku,
                    "item_handle": data.product.handle,
                    "quantity": 1,
                    "item_variant": data.variant.title,
                    "item_variant_id": data.variant.id,
                    "price": data.variant.price / 100,
                    "id": `shopify_IT_${data.product.id}_${data.variant.id}`,
                    "google_business_vertical": "retail",
                    "index": 1
                }
            ]
        },
        "gtm.uniqueEventId": 21
    }

      window.dataLayer = window.dataLayer || [];
      
      try{
      const ee_view_item_index = window.dataLayer.findIndex((item) => item.event === 'ee_view_item');
      if(ee_view_item_index > -1){
        window.dataLayer.splice(ee_view_item_index, 1);
      }
    }catch(err){}

        window.dataLayer.push(obj);

    }

    /**
     * Auto-seleziona una variante disponibile quando l'utente sceglie un'opzione non disponibile
     * @param {HTMLElement} changedInput - L'input che è stato modificato
     * @param {Array} selectedOptions - Le opzioni attualmente selezionate
     */
    autoSelectAvailableVariant(changedInput, selectedOptions) {
      const changedSelector = changedInput.closest('.option-selector');
      const changedOptionIndex = Array.from(this.optionSelectors).indexOf(changedSelector);

      // Trova tutte le varianti disponibili che hanno l'opzione appena selezionata
      const availableVariantsWithOption = this.data.product.variants.filter(v =>
        v.available && v.options[changedOptionIndex] === selectedOptions[changedOptionIndex]
      );

      if (availableVariantsWithOption.length > 0) {
        // Prendi la prima variante disponibile con questa opzione
        const targetVariant = availableVariantsWithOption[0];

        // Cambia automaticamente le altre opzioni per matchare questa variante disponibile
        this.optionSelectors.forEach((selector, index) => {
          if (index !== changedOptionIndex) {
            const targetValue = targetVariant.options[index];

            if (selector.dataset.selectorType === 'dropdown') {
              // Gestione dropdown
              const options = selector.querySelectorAll('.custom-select__option');
              const targetOption = Array.from(options).find(opt => opt.dataset.value === targetValue);
              if (targetOption) {
                targetOption.click();
              }
            } else {
              // Gestione radio buttons
              const inputs = selector.querySelectorAll('.js-option');
              const targetInput = Array.from(inputs).find(input => input.value === targetValue);
              if (targetInput && !targetInput.checked) {
                targetInput.checked = true;
                targetInput.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          }
        });
      }
    }

    /**
     * Updates the "Add to Cart" button label and disabled state.
     */
    updateAddToCartButton() {
      this.productForm = this.section.querySelector('.js-product-form-main');
      if (!this.productForm) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;
      const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;

      this.addBtn.disabled = !variantAvailable;
      this.addBtn.textContent = variantAvailable
        ? this.addBtn.dataset.addToCartText
        : unavailableStr;
    }


    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {

     

      if (this.dataset.showAvailability === 'false') return;
      let currVariant = this.variant;

      if (!this.variant) {
        currVariant = { options: this.getSelectedOptions() };
      }

      const updateOptionAvailability = (optionEl, available, soldout) => {
        const el = optionEl;
        const text = soldout ? theme.strings.noStock : theme.strings.noVariant;
        el.classList.toggle('is-unavailable', !available);

        if (optionEl.classList.contains('custom-select__option')) {
          const em = el.querySelector('em');

          if (em) {
            em.hidden = available;
          }

          if (!available) {
            if (em) {
              em.textContent = text;
            } else {
              el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${text}</em>`;
            }
          }
        } else {
          try{
            el.nextElementSibling.removeAttribute('title');
          }catch(err){}
        }
      };

      // Flag all options as unavailable
      this.querySelectorAll('.js-option').forEach((optionEl) => {
        updateOptionAvailability(optionEl, false, false);
      });

      // Flag selector options as available or sold out, depending on the variant availability
      this.optionSelectors.forEach((selector, selectorIndex) => {
        this.data.product.variants.forEach((variant) => {
          let matchCount = 0;

          variant.options.forEach((option, optionIndex) => {
            if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
              matchCount += 1;
            }
          });

          if (matchCount === currVariant.options.length - 1) {
            const options = selector.querySelectorAll('.js-option');
            const optionEl = Array.from(options).find((opt) => {
              if (selector.dataset.selectorType === 'dropdown') {
                return opt.dataset.value === variant.options[selectorIndex];
              }
              return opt.value === variant.options[selectorIndex];
            });

            if (optionEl) {
              updateOptionAvailability(optionEl, variant.available, !variant.available);
            }
          }
        });
      });
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default')
            ? ''
            : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }

    /**
     * Updates the product media.
     */
    updateMedia() {
      if (!this.variant.featured_media) return;

      if (this.section.matches('quick-add-drawer')) {
        this.section.updateMedia(this.variant.featured_media.id);
      } else {
        this.mediaGallery = this.mediaGallery || this.section.querySelector('media-gallery');
        if (!this.mediaGallery) return;

        const variantMedia = this.mediaGallery.querySelector(
          `[data-media-id="${this.variant.featured_media.id}"]`
        );
        this.mediaGallery.setActiveMedia(variantMedia, true, true);
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.price = this.price || this.section.querySelector('.product-info__price > .price');
      if (!this.price) return;

      if (this.variant) {
        const priceCurrentEl = this.price.querySelector('.price__current');
        const priceWasEl = this.price.querySelector('.price__was');
        const unitPriceEl = this.price.querySelector('.unit-price');

        // Update current price and original price if on sale.
        priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price;
        if (priceWasEl)
          priceWasEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice || '';

        // Update unit price, if specified.
        if (this.variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = this.variant.unit_price_measurement.reference_value;
          const unit = this.variant.unit_price_measurement.reference_unit;

          valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
        }

        unitPriceEl.hidden = !this.variant.unit_price_measurement;
        this.price.classList.toggle(
          'price--on-sale',
          this.variant.compare_at_price > this.variant.price
        );
        this.price.classList.toggle('price--sold-out', !this.variant.available);

        // IB-600: badge sconto (-X%) affiancato al prezzo, aggiornato per
        // variante. Prezzi in centesimi (interi) dal JSON variante.
        const discountEl = this.section.querySelector('.product-info__price-discount');
        if (discountEl) {
          const onSale =
            this.variant.compare_at_price > this.variant.price && this.variant.price > 0;
          if (onSale) {
            const disc = Math.round(
              ((this.variant.compare_at_price - this.variant.price) /
                this.variant.compare_at_price) *
                100
            );
            discountEl.textContent = '-' + disc + '%';
            discountEl.hidden = false;
          } else {
            discountEl.hidden = true;
          }
        }
      }

      this.price.querySelector('.price__default').hidden = !this.variant;
      this.price.querySelector('.price__no-variant').hidden = this.variant;
    }

    /**
     * Updates the weight.
     */
    updateWeight() {
      this.weights = this.weights || this.section.querySelectorAll('.product-info__weight');
      if (this.weights.length === 0) return;

      const weightAvailable = this.variant && this.variant.weight > 0;
      this.weights.forEach((weight) => {
        weight.textContent = weightAvailable ? this.data.formatted[this.variant.id].weight : '';
        weight.hidden = !weightAvailable;
      });
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcodes = this.barcodes || this.section.querySelectorAll('.product-info__barcode-value');
      if (this.barcodes.length === 0) return;

      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcodes.forEach((barcode) => {
        barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
        barcode.parentNode.hidden = !barcodeAvailable;
      });
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}`);
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms =
        this.forms || this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        input.value = this.variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          selectedOptions.push(selector.querySelector('.custom-select__btn').textContent.trim());
        } else {
          // I selettori "mono variante" (colore o taglia unica resi come testo)
          // non hanno radio: espongono il valore in un <input type="hidden">.
          // Cercando solo `input:checked` si otteneva null e il `.value`
          // sollevava un TypeError, interrompendo updateAvailability() prima
          // che marcasse alcunche': su quei prodotti le combinazioni esaurite
          // restavano indistinguibili da quelle acquistabili.
          const input = selector.querySelector('input:checked')
            || selector.querySelector('input.js-option');

          selectedOptions.push(input ? input.value : null);
        }
      });

      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }
  }

  customElements.define('variant-picker', VariantPicker);
}

/* IB - bug 451039/451602.
   Prima queste due routine (conversione taglia universale + ordinamento)
   giravano solo su 'DOMContentLoaded'. Il drawer Quick Add inietta il markup
   del prodotto via innerHTML, che NON esegue gli script inline: nel drawer le
   taglie restavano quindi nell'ordine grezzo delle option values di Shopify.
   Ora sono funzioni riutilizzabili su window, invocabili anche dopo un render
   dinamico (vedi quick-add.js). */
window.IBVariantPicker = window.IBVariantPicker || {};

/**
 * Sostituisce le taglie con la taglia universale (metafield custom.universal_size).
 * La sostituzione avviene SOLO se ogni valore mostrato ha una corrispondenza:
 * convertirne una parte sola mescolava scale diverse (es. "44,5" EU in mezzo
 * a taglie US 6-13), rendeva l'ordinamento incoerente e disallineava la PDP
 * dal carrello, che mostra sempre il valore grezzo della variante.
 * @param {Element|Document} [root] - Radice in cui operare.
 */
window.IBVariantPicker.applyUniversalSizes = function (root) {
  const scope = root || document;
  const dataEl = scope.querySelector('#unisizeobj');
  if (!dataEl) return;

  let map;
  try {
    map = (JSON.parse(dataEl.textContent) || {}).unisizeobj || {};
  } catch (e) {
    return;
  }

  const keys = Object.keys(map);
  if (!keys.length) return;

  scope.querySelectorAll('.option-selector__btns').forEach((wrapper) => {
    const spans = Array.from(wrapper.querySelectorAll('span[data-value]'));
    if (!spans.length) return;

    // Copertura parziale: si lascia la scala originale.
    const fullyMapped = spans.every((span) => map[span.dataset.value] !== undefined);
    if (!fullyMapped) return;

    spans.forEach((span) => {
      const converted = map[span.dataset.value];
      span.innerHTML = converted;

      const splitted = String(converted).split(' ');
      const orderValue = splitted.length > 1 ? `${splitted[0]}.5` : converted;
      span.parentElement.setAttribute('data-order-value', orderValue);
      span.parentElement.setAttribute('data-converted', 'true');
    });
  });
};

/**
 * Ordina le taglie mostrate dal variant picker.
 * @param {Element|Document} [root] - Radice in cui operare.
 */
window.IBVariantPicker.sortSizeOptions = function (root) {
  const scope = root || document;

  // Mappa taglie letterali (ordine crescente)
  const letterSizeOrder = {
    'XXXS': 10,
    'XXS': 20,
    'XS': 30,
    'S': 40,
    'M': 50,
    'L': 60,
    'XL': 70,
    'XXL': 80,
    'XXXL': 90,
    '2XL': 80,
    '3XL': 90,
    '4XL': 100,
    '5XL': 110,
    // Taglie bambino
    'OS': 1000, // One Size alla fine
    'TU': 1000, // Taglia Unica
    'UNICA': 1000
  };

  // Peso per suffissi alfabetici (a, b, c dopo il numero)
  const letterSuffixWeight = {
    'A': 0.001,
    'B': 0.002,
    'C': 0.003,
    'D': 0.004,
    'E': 0.005,
    'F': 0.006,
    'G': 0.007,
    'H': 0.008,
    'I': 0.009,
    'J': 0.010,
    'K': 0.011,
    'L': 0.012,
    'M': 0.013,
    'N': 0.014,
    'O': 0.015,
    'P': 0.016,
    'Q': 0.017,
    'R': 0.018,
    'S': 0.019,
    'T': 0.020
  };

  const parseSize = (label) => {
    const rawValue = (label.getAttribute('data-order-value') || label.querySelector('span')?.textContent || label.textContent || "").trim().toUpperCase();

    // 1. Controlla se è una taglia letterale (S, M, L, XL, XXS, etc.)
    if (letterSizeOrder[rawValue] !== undefined) {
      return letterSizeOrder[rawValue];
    }

    // 2. Controlla combinazioni come "S/M", "M/L" - usa la prima taglia + 0.5
    const slashMatch = rawValue.match(/^([A-Z]+)\/([A-Z]+)$/);
    if (slashMatch && letterSizeOrder[slashMatch[1]] !== undefined) {
      return letterSizeOrder[slashMatch[1]] + 0.5;
    }

    // 3. Gestisci numeri con spazio e frazione PRIMA dei range (es. "35 1/3", "36 2/3")
    // Queste devono venire PRIMA del range successivo
    const fractionMatch = rawValue.match(/^(\d+)\s+(\d+)\/(\d+)$/);
    if (fractionMatch) {
      const whole = parseInt(fractionMatch[1]);
      const numerator = parseInt(fractionMatch[2]);
      const denominator = parseInt(fractionMatch[3]);
      // es. "35 1/3" = 35.333, "35 2/3" = 35.666
      return whole + (numerator / denominator);
    }

    // 4. Gestisci range numerici come "35-36", "37-38"
    // Questi rappresentano taglie intermedie, quindi vanno DOPO le frazioni
    // es. "35-36" dovrebbe venire dopo "35 1/3" (35.333) e "35 2/3" (35.666)
    // Lo posizioniamo a 35.9 (quasi 36 ma prima di 36)
    const rangeMatch = rawValue.match(/^(\d+(?:[.,]\d+)?)\s*[-]\s*(\d+(?:[.,]\d+)?)$/);
    if (rangeMatch) {
      const firstNum = parseFloat(rangeMatch[1].replace(',', '.'));
      // Posiziona il range quasi alla fine del primo numero (0.9)
      return firstNum + 0.9;
    }

    // 5. Gestisci numeri con suffisso lettera (es. "41A", "42B", "38H")
    const numLetterMatch = rawValue.match(/^(\d+(?:[.,]\d+)?)([A-Z])$/);
    if (numLetterMatch) {
      const base = parseFloat(numLetterMatch[1].replace(',', '.'));
      const suffix = numLetterMatch[2];
      const extra = letterSuffixWeight[suffix] || 0;
      return base + extra;
    }

    // 6. Gestisci numeri semplici con possibile decimale (es. "42", "42.5", "42,5")
    const simpleNumMatch = rawValue.match(/^(\d+(?:[.,]\d+)?)$/);
    if (simpleNumMatch) {
      return parseFloat(simpleNumMatch[1].replace(',', '.'));
    }

    // 7. Gestisci numeri con prefisso/suffisso misto (es. "EU42", "42EU", "UK8")
    const prefixSuffixMatch = rawValue.match(/^([A-Z]*)(\d+(?:[.,]\d+)?)([A-Z]*)$/);
    if (prefixSuffixMatch) {
      const num = parseFloat(prefixSuffixMatch[2].replace(',', '.'));
      const suffix = prefixSuffixMatch[3];
      const extra = letterSuffixWeight[suffix] || 0;
      return num + extra;
    }

    // 8. Fallback: cerca qualsiasi numero nella stringa
    const anyNumMatch = rawValue.match(/(\d+(?:[.,]\d+)?)/);
    if (anyNumMatch) {
      return parseFloat(anyNumMatch[1].replace(',', '.'));
    }

    // 9. Non riconosciuto - metti alla fine
    return 99999;
  };

  scope.querySelectorAll('.option-selector__btns').forEach(wrapper => {
    // Cerca label con data-value o con span[data-value]
    const labels = Array.from(wrapper.querySelectorAll('label.opt-label--btn, label[for]'));

    if (labels.length < 2) return; // niente da ordinare

    // Calcola il valore di ordinamento
    labels.forEach(label => {
      const order = parseSize(label);
      label.setAttribute('data-order', order);
    });

    // Ordina le label
    const sortedLabels = [...labels].sort((a, b) => {
      return parseFloat(a.dataset.order) - parseFloat(b.dataset.order);
    });

    // Salva input associati per non perderli
    const inputs = Array.from(wrapper.querySelectorAll('input.js-option'));

    // Pulizia wrapper
    wrapper.innerHTML = '';

    // Ricomponi coppie input + label ordinati
    sortedLabels.forEach(label => {
      const inputId = label.getAttribute('for');
      const input = inputs.find(i => i.id === inputId);
      if (input) wrapper.appendChild(input);
      wrapper.appendChild(label);
    });

  });
};

/**
 * Conversione taglia universale + ordinamento, nell'ordine corretto.
 * Idempotente: puo' essere richiamata dopo ogni render dinamico.
 * @param {Element|Document} [root] - Radice in cui operare.
 */
window.IBVariantPicker.apply = function (root) {
  window.IBVariantPicker.applyUniversalSizes(root);
  window.IBVariantPicker.sortSizeOptions(root);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => window.IBVariantPicker.apply(document));
} else {
  window.IBVariantPicker.apply(document);
}
